import React from 'react';
import { useParams } from 'react-router';

import CommunityLoad from './CommunityLoad';

const Community = () => {
  const { communityId, competitorId } = useParams();
  const id = communityId || competitorId;

  return <CommunityLoad communityId={parseInt(id || '')} />;
};

export default Community;
